"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateQuickBetValue = void 0;
const basket_quick_bet_types_1 = require("../basket-quick-bet.types");
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const selectors_1 = require("../selectors");
const validateQuickBetValue = (value, minBet, balance) => {
    if (value < minBet) {
        return basket_quick_bet_types_1.EBasketQuickBetError.minBetError;
    }
    if (value > balance) {
        return basket_quick_bet_types_1.EBasketQuickBetError.insufficientBalance;
    }
    return null;
};
const useValidateQuickBetValue = (value) => {
    const { minBet, balance } = (0, react_redux_1.useSelector)(selectors_1.selectValidationData);
    return (0, react_1.useMemo)(() => validateQuickBetValue(value, minBet, balance), [value, minBet, balance]);
};
exports.useValidateQuickBetValue = useValidateQuickBetValue;
//# sourceMappingURL=useValidateQuickBetValue.js.map